/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { shared_FlexibleDate } from './shared_FlexibleDate';
export type contacts_UpdateContactRequest = {
    addressForm?: contacts_UpdateContactRequest.addressForm;
    addressId?: string;
    avatarUrl?: string;
    birthdate?: shared_FlexibleDate;
    clerkUserId?: string;
    contactInternalId?: string;
    customerScore?: number;
    /**
     * Primary email. An empty string clears the stored address; omitting the field keeps it.
     */
    emailMain?: string;
    /**
     * Secondary email. An empty string clears the stored address; omitting the field keeps it.
     */
    emailSecond?: string;
    employer?: string;
    firstname?: string;
    gender?: contacts_UpdateContactRequest.gender;
    labels?: Array<string>;
    languageCorrespondence?: contacts_UpdateContactRequest.languageCorrespondence;
    lastname?: string;
    nationalities?: Array<string>;
    notes?: string;
    profession?: string;
    status?: contacts_UpdateContactRequest.status;
    telHome?: string;
    telHomeCountryCode?: string;
    telMobile?: string;
    telMobileCountryCode?: string;
    telWork?: string;
    telWorkCountryCode?: string;
    title?: string;
};
export namespace contacts_UpdateContactRequest {
    export enum addressForm {
        FORMAL = 'FORMAL',
        INFORMAL = 'INFORMAL',
    }
    export enum gender {
        MALE = 'MALE',
        FEMALE = 'FEMALE',
        OTHER = 'OTHER',
        UNKNOWN = 'UNKNOWN',
        UNDEFINED = 'UNDEFINED',
    }
    export enum languageCorrespondence {
        EN = 'en',
        DE = 'de',
    }
    export enum status {
        ACTIVE = 'ACTIVE',
        INACTIVE = 'INACTIVE',
        UPCOMING = 'UPCOMING',
    }
}

